type JsonRecord = Record<string, any>

export function checkParamsToOverrideLocalConfig(
  config: JsonRecord,
  sourceConfig: JsonRecord,
  configModel: JsonRecord,
): JsonRecord {
  Object.keys(sourceConfig).forEach((objectKey) => {
    if (
      Object.prototype.hasOwnProperty.call(config, objectKey)
      && Object.prototype.hasOwnProperty.call(configModel, objectKey)
    ) {
      if (
        typeof configModel[objectKey] === 'object'
        && typeof config[objectKey] === 'object'
        && typeof sourceConfig[objectKey] === 'object'
        && sourceConfig[objectKey] !== null
        // eslint-disable-next-line no-param-reassign
        && config[objectKey] !== null
      ) {
        checkParamsToOverrideLocalConfig(
          config[objectKey],
          sourceConfig[objectKey],
          configModel[objectKey],
        )
      } else if (sourceConfig[objectKey]) {
        // eslint-disable-next-line no-param-reassign
        config[objectKey] = sourceConfig[objectKey]
      }
    }
  })

  return config
}

export function getCustomResourceBaseUrlFromConfigLocation(
  configLocation?: string | null,
): string | undefined {
  if (!configLocation) return undefined
  const configPath = 'config/'
  return configLocation.endsWith(configPath)
    ? configLocation.slice(0, configLocation.lastIndexOf(configPath))
    : configLocation
}
